import { HANDLE } from 'constants/bounding-box';
import { Widget } from 'types/widget.types';
import { isSvg } from 'utils/file';

import { isSquareFrame } from './Frame';
import { FilterEffect, FilterName, ImageFilterEffectProps, ImageWidgetData } from './ImageWidget.types';

export const BOUNDING_BOX_CONFIG = {
  customHandle: (activeWidget: Widget) => {
    const imageWidgetData = activeWidget as ImageWidgetData;
    if (isSvg(imageWidgetData.url)) return HANDLE.CORNERS;
    if (isSquareFrame(imageWidgetData.frame)) return HANDLE.CORNERS;
    return HANDLE.ALL;
  },
};

export const CROP_BUTTON_ID = 'crop-button';

export const TRACKING_DEBOUNCE_MS = 200;

export const FILTER_MULTIPLY_FACTOR = 0.7;
export const ADJUSTMENT_MAX = 100;
export const ADJUSTMENT_MIN = -100;

export const FILTER_LIST: Array<Omit<ImageFilterEffectProps, 'onFilterEffect' | 'selectedFilter'>> = [
  {
    filterName: 'None',
    sampleSrc: require('assets/images/img_filter_none.png'),
  },
  {
    filterName: 'Greyscale',
    sampleSrc: require('assets/images/img_filter_greyscale.png'),
  },
  {
    filterName: 'Sepia',
    sampleSrc: require('assets/images/img_filter_sepia.png'),
  },
  {
    filterName: 'Warm',
    sampleSrc: require('assets/images/img_filter_warm.png'),
  },
  {
    filterName: 'Cool',
    sampleSrc: require('assets/images/img_filter_cool.png'),
  },
  {
    filterName: 'Retro',
    sampleSrc: require('assets/images/img_filter_retro.png'),
  },
];

export const FILTER_CONFIG: Record<FilterName, FilterEffect> = {
  None: {
    brightness: 0,
    contrast: 0,
    saturation: 0,
    tint: 0,
  },
  Cool: {
    brightness: -15,
    contrast: 15,
    saturation: 40,
    tint: 10,
  },
  Greyscale: {
    brightness: 30,
    contrast: -40,
    saturation: -200,
    tint: 0,
  },
  Retro: {
    brightness: 0,
    contrast: 30,
    saturation: 40,
    tint: -26,
  },
  Sepia: {
    brightness: -15,
    contrast: 15,
    saturation: 70,
    tint: -156,
  },
  Warm: {
    brightness: -15,
    contrast: 15,
    saturation: 40,
    tint: -130,
  },
};
